import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const MarkenServiceConfig = {
  name: "Marken",
  annotations: []
} as ServiceConfig;